import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiGlobe } = FiIcons;

const LanguageSelector = ({ language, setLanguage }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
      className="fixed top-24 right-6 z-40"
    >
      <div className="bg-white/90 backdrop-blur-sm rounded-xl p-2 border border-stone-200 shadow-lg">
        <div className="flex items-center space-x-2">
          <SafeIcon icon={FiGlobe} className="text-amber-700" />
          <div className="flex space-x-1">
            <button
              onClick={() => setLanguage('en')}
              className={`px-3 py-1 rounded-lg text-sm font-medium transition-all ${
                language === 'en'
                  ? 'bg-gradient-to-r from-amber-600 to-amber-700 text-white'
                  : 'text-stone-600 hover:text-stone-800'
              }`}
            >
              EN
            </button>
            <button
              onClick={() => setLanguage('th')}
              className={`px-3 py-1 rounded-lg text-sm font-medium transition-all ${
                language === 'th'
                  ? 'bg-gradient-to-r from-amber-600 to-amber-700 text-white'
                  : 'text-stone-600 hover:text-stone-800'
              }`}
            >
              ไทย
            </button>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default LanguageSelector;